module.exports = __webpack_public_path__ + "static/media/avatar.d874068d.png";